import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import useStore from "../hooks/useStore";
import {ProgressSpinner} from "primereact/progressspinner";

export const LoaderComponent: React.FC = () => {
    return <div style={{height:'100vh'}} className='flex justify-content-center align-items-center'>;
        <ProgressSpinner />
    </div>
}

const PrivateRoute = ({ children }:any) => {
    const { accessToken, loader } = useStore();
    const location = useLocation();

    if (loader) {
        return <LoaderComponent/>;
    }
    if (!accessToken) {
        return <Navigate to='/auth/login' state={{ from: location }} />;
    }
    return children;
};

export default PrivateRoute;